import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import ActionButton from 'Utils/Helpers/ActionButton';
import { setOpenStatusHistory } from '../../../../../../Redux/slices/globalSlice';
import StatusShow from '../GridStatus/StatusShow';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function LogStatusHistory({ data, patient }) {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const { openStatusHistory, current } = useSelector((state) => ({
        openStatusHistory: state.setting.openStatusHistory,
        current: state.staff.current,
    }));

    useEffect(() => {
        if(openStatusHistory.open) {
            setShow(true);
            dispatch(setOpenStatusHistory({ open: false, tab: '1' }));
        }
    },[openStatusHistory.open])

    const setShowDialog = () => {
        setShow(true);
    }

    const handleClose= () => {
        setShow(false);
    }

    return (
        <>
            <ActionButton
                icon={<icons.ClockHistory/>}
                onClick={setShowDialog}
                disabled={!current[1][2]}
                hidden={!current[1][2]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    TransitionComponent={Transition}
                    keepMounted
                    fullWidth={true}
                    maxWidth={'md'}
                    // TransitionProps={{onEnter: onEnter}}
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                    <DialogTitle>
                        {`سابقه‌ها (${patient})`}
                        <div className='close-btn' onClick={handleClose}>
                            <icons.X/>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <>
                            {
                                (data && data.length !== 0) &&
                                <div className="w-100 mb-4 text-center">
                                {
                                    data.map((item, index) => {
                                    return(
                                        <StatusShow
                                            key={`StatusShow_${Date.now()}_${data.id}_${item.id}`}
                                            data={data}
                                            item={item}
                                            close={handleClose}
                                            patient={false}
                                            index={index}
                                            noChange
                                        />
                                    )
                                    })
                                }
                                </div>
                            }
                        </>
                    </DialogContent>
                </Dialog>
            }
        </>
    );
}